// Енамка для типов ошибок валидации
export enum ValidationErrorType {
  Phone = 'phone',
  Agreement = 'agreement',
  MortgageAmount = 'mortgageAmount',
  MortgageRate = 'mortgageRate',
}

export type ValidationError = {
  text: string;
  type: ValidationErrorType;
} | null;

export interface ILead {
  phone: string;
  hasMortgage: boolean;
  mortgageAmountRemaining?: number;
  mortgageRate?: number;
  agreeToGetAds: boolean;
}

export interface IRefinLeadBannerProps {
  sendLead: (phone: string) => void;
  sendRefinLead: (lead: ILead) => void;
  isLeadSuccessfullySent: boolean;
  isLeadSending: boolean;
  isRefinLeadSuccessfullySent: boolean;
  isRefinLeadSending: boolean;
  isLeadError: boolean;
  isRefinLeadError: boolean;
}
